import React, { useEffect, useState } from 'react';
import {
  Modal, Icon, Dimmer, Loader, Message, Table, Segment, Header, Label, Button
} from 'semantic-ui-react';
import { API, showError } from '../helpers';

const VRAMCheckModal = ({ open, onClose, modelId, modelName }) => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && modelId) {
      setLoading(true);
      API.get(`/api/model-manager/vram-check/${modelId}`)
        .then(res => {
          const { success, data } = res.data;
          if (success) setResult(data);
          else showError(res.data.message);
        })
        .catch(e => showError(e.message))
        .finally(() => setLoading(false));
    }
  }, [open, modelId]);

  return (
    <Modal open={open} onClose={onClose} size='small'>
      <Modal.Header>
        <Icon name='microchip' /> 显存预检 - {modelName}
      </Modal.Header>
      <Modal.Content>
        {loading ? (
          <Dimmer active inverted><Loader /></Dimmer>
        ) : result ? (
          <div>
            {result.can_start ? (
              <Message positive>
                <Message.Header>显存充足</Message.Header>
                <p>可以安全启动此模型</p>
              </Message>
            ) : (
              <Message negative>
                <Message.Header>显存不足</Message.Header>
                <p>{result.error_message}</p>
              </Message>
            )}
            {result.gpu_details && (
              <Table compact size='small'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>GPU</Table.HeaderCell>
                    <Table.HeaderCell>可用</Table.HeaderCell>
                    <Table.HeaderCell>需要</Table.HeaderCell>
                    <Table.HeaderCell>状态</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {result.gpu_details.map(d => (
                    <Table.Row key={d.gpu_index} positive={d.sufficient} negative={!d.sufficient}>
                      <Table.Cell>GPU {d.gpu_index}</Table.Cell>
                      <Table.Cell>{d.available_mb} MB</Table.Cell>
                      <Table.Cell>{d.required_mb} MB</Table.Cell>
                      <Table.Cell>
                        <Icon name={d.sufficient ? 'check' : 'close'} color={d.sufficient ? 'green' : 'red'} />
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            )}
            {result.suggestions && result.suggestions.length > 0 && (
              <Segment>
                <Header as='h5'>释放建议</Header>
                {result.suggestions.map((s, i) => (
                  <Label key={i} style={{ margin: 2 }}>
                    {s.model_name} ({s.free_mb} MB)
                    {s.is_resident && <Label.Detail>常驻</Label.Detail>}
                  </Label>
                ))}
              </Segment>
            )}
          </div>
        ) : null}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>关闭</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default VRAMCheckModal;
